import styled from 'styled-components'

import { WalletModelShort } from '@root/entities/wallet/ui'
import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'
import { AmountFormatted } from '@root/shared/core/format'

import type { CurrencyModel } from '@root/entities/currency'
import type { WalletModel } from '@root/entities/wallet/atoms'
import type BigNumber from 'bignumber.js'

type TransferCardProps = {
  balance: BigNumber
  wallet: WalletModel
  currency: CurrencyModel
}

export const TransferWalletInfo: React.FC<TransferCardProps> = ({
  wallet,
  balance,
  currency,
}) => {
  return (
    <Root>
      <WalletModelShort wallet={wallet} />
      <Line>
        <Address walletAddress={wallet.address} withCopy />
        <Balance>
          <AmountFormatted
            amount={balance}
            currency={currency.ticker}
            roundingMode="trunc"
          />
        </Balance>
      </Line>
    </Root>
  )
}

const Balance = styled.div`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`

const Address = styled(WalletAddressTruncated)`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  gap: 10px;
`

const Line = styled.div`
  padding-left: 14px;
  color: var(--text-9);
  flex-wrap: wrap;

  display: flex;
  justify-content: start;
  column-gap: 10px;
`

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
